define([], function () {
    'use strict';

    return {
        SITE_ASSETS_SERVER: {
            FIXED_PAGE_JASON_PATH: '/fixedData'
        }
    };
});
